import {
	Component,
	Input,
	OnInit,
	OnDestroy,
	HostBinding
} from '@angular/core';
import { Timer } from 'go-modules/timer/timer';
import { TimeUtilsService } from 'go-modules/time/time.service';
import { TranslateService } from '@ngx-translate/core';
import humanizeDuration from 'humanize-duration';

@Component({
	selector: 'time-remaining-countdown',
	templateUrl: './time-remaining-countdown.component.html',
	styleUrls: ['./time-remaining-countdown.component.scss']
})
export class TimeRemainingCountdownComponent implements OnInit, OnDestroy {
	@Input() public timer!: Timer;
	@Input() public timeLimit!: number;

	public timeDisplayHtml = '';

	@HostBinding('class.show-time-display') public showTimeDisplay = false;
	@HostBinding('class.hidden') public isHidden = false;

	constructor (
		private timeUtils: TimeUtilsService,
		private translate: TranslateService
	) {}

	public ngOnInit () {
		if (!this.timer) {
			throw new Error('`timer` input is required');
		}
		this.timer.on(Timer.EVENT.TIME, this.updateTime);
	}

	public ngOnDestroy () {
		if (this.timer) {
			this.timer.off(Timer.EVENT.TIME, this.updateTime);
		}
	}

	private updateTime = (elapsedMs: number): void => {
		const secondsElapsed = this.timeUtils.millisecondsToSeconds(elapsedMs);
		const timeRemainingMs =
			Math.ceil(this.timeLimit * 60 - secondsElapsed) * 1000;

		const shouldShow = this.shouldDisplay(timeRemainingMs);
		this.showTimeDisplay = shouldShow;
		this.isHidden = timeRemainingMs <= 0;

		if (shouldShow) {
			this.timeDisplayHtml = this.formatTime(timeRemainingMs);
		}
	};

	private shouldDisplay (ms: number): boolean {
		const secs = Math.ceil(this.timeUtils.millisecondsToSeconds(ms));
		return secs > 0 && (secs === 60 || secs === 30 || secs <= 10);
	}

	private formatTime (ms: number): string {
		const lang =
			this.translate.currentLang ||
			this.translate.defaultLang ||
			'en';
		return humanizeDuration(ms, { language: lang });
	}
}
